import { create } from 'zustand';
import { contactoService } from '../services/contacto/contacto.service';
import { webSocketService } from '../services/websocket/websocket.service';

interface ContactNotificationsState {
  totalNuevos: number;
  totalMensajes: number;
  setStats: (stats: { totalNuevos: number; totalMensajes: number }) => void;
  incrementNuevos: () => void;
  decrementNuevos: () => void;
  refreshStats: () => Promise<void>;
}

export const useContactNotificationsStore = create<ContactNotificationsState>((set) => {
  // Singleton listener: se registra una sola vez al crear el store
  const handleNewMessage = () => {
    set((state) => ({
      totalNuevos: state.totalNuevos + 1,
      totalMensajes: state.totalMensajes + 1,
    }));
  };

  webSocketService.addContactMessageListener(handleNewMessage);

  // Polling cada 60 segundos como fallback (una sola vez)
  const refresh = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token || token === 'undefined' || token === 'null') return;

    try {
      const stats = await contactoService.obtenerStats();
      set({ totalNuevos: stats.totalNuevos, totalMensajes: stats.totalMensajes });
    } catch (error) {
      console.error('Error fetching contact stats:', error);
    }
  };

  refresh();
  const intervalId = setInterval(refresh, 60000);

  // Limpiar al recargar la página (no hay unmount en store global,
  // pero registramos el cleanup por si acaso)
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => {
      clearInterval(intervalId);
      webSocketService.removeContactMessageListener(handleNewMessage);
    });
  }

  return {
    totalNuevos: 0,
    totalMensajes: 0,

    setStats: (stats) => set({ totalNuevos: stats.totalNuevos, totalMensajes: stats.totalMensajes }),

    incrementNuevos: () =>
      set((state) => ({
        totalNuevos: state.totalNuevos + 1,
        totalMensajes: state.totalMensajes + 1,
      })),

    decrementNuevos: () =>
      set((state) => ({
        totalNuevos: Math.max(0, state.totalNuevos - 1),
      })),

    refreshStats: refresh,
  };
});
